(function (global) {
  if (global.BionoboGuideLibrary && global.BionoboGuideLibrary.__controllerReady) {
    if (typeof document !== 'undefined') {
      document.querySelectorAll('[data-bn-guide-library]').forEach(global.BionoboGuideLibrary.init);
    }
    if (typeof module === 'object' && module.exports) module.exports = global.BionoboGuideLibrary;
    return;
  }

  function normalizeText(value) {
    return String(value || '').trim().toLocaleLowerCase();
  }

  function filterGuides(items, query, category) {
    var normalizedQuery = normalizeText(query);
    var normalizedCategory = normalizeText(category || '__all__');

    return items.filter(function (item) {
      var categories = Array.isArray(item.categories)
        ? item.categories.map(normalizeText).filter(Boolean)
        : [];
      var categoryMatch = normalizedCategory === '__all__'
        || categories.length === 0
        || categories.includes(normalizedCategory);
      var queryMatch = normalizedQuery === '' || normalizeText(item.text).includes(normalizedQuery);
      return categoryMatch && queryMatch;
    });
  }

  function init(root) {
    if (!root || root.__bnGuideLibraryInitialized) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bn-guide-card]')).map(function (element) {
      return {
        element: element,
        categories: (element.dataset.categories || '').split(',').map(normalizeText).filter(Boolean),
        text: element.dataset.search || '',
      };
    });
    var search = root.querySelector('[data-bn-guide-search]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-bn-guide-filter]'));
    var empty = root.querySelector('[data-bn-guide-empty]');
    var status = root.querySelector('[data-bn-guide-status]');
    var query = '';
    var category = '__all__';

    function updateFilters() {
      filters.forEach(function (button) {
        var active = normalizeText(button.dataset.category || '__all__') === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function render() {
      var visible = filterGuides(cards, query, category);
      cards.forEach(function (card) {
        card.element.hidden = visible.indexOf(card) === -1;
      });
      if (empty) empty.hidden = visible.length !== 0;
      if (status) {
        status.textContent = visible.length === 1
          ? root.dataset.resultOne
          : root.dataset.resultPrefix + visible.length + root.dataset.resultSuffix;
      }
    }

    if (search) {
      search.addEventListener('input', function () {
        query = search.value;
        render();
      });
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        category = normalizeText(button.dataset.category || '__all__');
        updateFilters();
        render();
      });
    });

    root.__bnGuideLibraryInitialized = true;
    updateFilters();
    render();
  }

  function handleSectionLoad(event) {
    var target = event && event.target;
    var root = target && target.matches && target.matches('[data-bn-guide-library]')
      ? target
      : target && target.querySelector
        ? target.querySelector('[data-bn-guide-library]')
        : null;
    if (root) init(root);
  }

  var api = {
    normalizeText: normalizeText,
    filterGuides: filterGuides,
    init: init,
    handleSectionLoad: handleSectionLoad,
    __controllerReady: true,
  };

  if (typeof module === 'object' && module.exports) module.exports = api;
  global.BionoboGuideLibrary = api;

  if (typeof document !== 'undefined') {
    function initializeAll() {
      document.querySelectorAll('[data-bn-guide-library]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', handleSectionLoad);
  }
})(typeof window === 'undefined' ? globalThis : window);
